export const notificationInboxQueryKeys = {
  root: ['notifications-inbox'] as const,
  unread: (tenantId: string) =>
    [...notificationInboxQueryKeys.root, tenantId, 'unread'] as const,
  list: (tenantId: string) =>
    [...notificationInboxQueryKeys.root, tenantId, 'list'] as const,
}
